<template>
  <el-container>
    <main class="tab__container">
      <h2 class="page__title">Домофоны</h2>
      <el-tabs v-model="activeTab">
        <el-tab-pane v-for="(tab, i) in tabs" :name="tab.key" :label="tab.name" :key="i">
          <component :is="tab.component" />
        </el-tab-pane>
      </el-tabs>
    </main>
  </el-container>
</template>

<script>
import IntercomsList from "@/components/Intercoms/tabs/IntercomsList";

export default {
  name: "Intercoms",
  data() {
    return {
      activeTab: "list",
      tabs: [
        {
          name: "Список",
          key: "list",
          component: IntercomsList,
        },
      ],
    };
  },
};
</script>
